import { render, staticRenderFns } from "./mark-sent-insurer.vue?vue&type=template&id=65089d96&scoped=true&"
import script from "./mark-sent-insurer.vue?vue&type=script&lang=js&"
export * from "./mark-sent-insurer.vue?vue&type=script&lang=js&"
import style0 from "./mark-sent-insurer.vue?vue&type=style&index=0&id=65089d96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65089d96",
  null
  
)

export default component.exports